import styled from 'styled-components'

export const Container = styled.article`
  background-color: #fff;
  width: 650px;
  max-width: 90vw;
  border-radius: 10px;
  overflow: hidden;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
`

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid var(--grey4);
`

export const Title = styled.h2`
  color: var(--dark);
`

export const CloseButton = styled.button`
  display: flex;
  padding: 0.25rem;
  border-radius: 0.25rem;
  background-color: transparent;
  transition-duration: 0.3s;

  &:hover {
    background-color: var(--grey5);
  }

  span.material-icons {
    font-size: 1.5rem;
    color: var(--grey21);
  }
`

export const Content = styled.div`
  padding: 1.5rem 2rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

export const Field = styled.div`
  label {
    color: var(--dark);
    font-size: 14px;
    font-weight: 500;
  }

  div {
    position: relative;
    display: flex;
    align-items: center;

    input {
      border: none;
      outline: none;
      padding: 0.75rem;
      padding-left: 2.5rem;
      margin: 4px 0;
      border: 1px solid var(--grey32);
      border-radius: 0.625rem;
      width: 100%;

      &:focus {
        border: 1.5px solid var(--blue);
      }
    }

    span {
      position: absolute;
      left: 0.75rem;
      color: var(--grey3);
    }
  }
`

export const OptionsContainer = styled.div`
  border: 1px solid var(--grey32);
  box-shadow: 0px 0px 10px 0px #00000040;
  margin-top: 0.25rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

export const OptionsList = styled.ul`
  list-style: none;
  padding: 0.5rem 0.125rem;
  margin: 0;
  overflow-y: auto;
`

export const Option = styled.button`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: transparent;
  width: 100%;

  &:hover {
    background-color: var(--blue13);
  }

  &.active {
    background-color: var(--grey26);
  }

  &:disabled:hover {
    cursor: not-allowed;

    &:not(.active) {
      background-color: transparent;
    }
  }

  span {
    color: var(--grey21);
  }
`

export const OptionDescription = styled.div`
  margin: 0 1rem;
  border-top: 1px solid var(--grey11);
  color: var(--grey15);
  font-size: 12px;
  padding: 0.75rem 0;
  display: flex;
  align-items: center;
  gap: 0.25rem;

  span.material-icons {
    font-size: 0.75rem;
  }

  span {
    color: var(--grey21);
  }
`

export const Footer = styled.footer`
  padding: 0.75rem 2rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.25rem;

  button {
    padding: 0.75rem 1rem;
    font-size: 14px;
    font-weight: 500;
    border-radius: 0.25rem;

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }

  button:first-child {
    border: 1px solid var(--grey11);
    color: var(--grey14);
    background: #fff;
  }

  button:last-child {
    background-color: var(--blue);
    color: #fff;
    padding: 0.75rem 1.5rem;
    overflow: hidden;
    position: relative;

    & > div {
      margin: 0;
      padding: 0;
      position: absolute;
      top: 0;
      left: 0;
      background: var(--blue);

      .lds-ring {
        transform: scale(0.6);

        div {
          border-color: #fff transparent transparent transparent;
        }
      }
    }
  }
`
